export default "__VITE_ASSET__C6ebHhap__"